import { UserRole } from '../contexts/AuthContext';

export const ROLE_PERMISSIONS = {
  view_only: ['view'],
  administrator: ['view', 'create', 'edit', 'delete', 'manage_users'],
  superadmin: ['view', 'create', 'edit', 'delete', 'manage_users', 'manage_roles']
} as const;

type Permission = 'view' | 'create' | 'edit' | 'delete' | 'manage_users' | 'manage_roles';

export function hasPermission(userRole: UserRole | null, permission: Permission): boolean {
  if (!userRole) return false;
  return ROLE_PERMISSIONS[userRole].includes(permission);
}

export function canManageUsers(userRole: UserRole | null): boolean {
  return hasPermission(userRole, 'manage_users');
}

export function canManageRoles(userRole: UserRole | null): boolean {
  return hasPermission(userRole, 'manage_roles');
}

export function canCreateContent(userRole: UserRole | null): boolean {
  return hasPermission(userRole, 'create');
}

export function canEditContent(userRole: UserRole | null): boolean {
  return hasPermission(userRole, 'edit');
}

export function canDeleteContent(userRole: UserRole | null): boolean {
  return hasPermission(userRole, 'delete');
}
